import { Box, Grid, SxProps, Theme, Typography } from '@mui/material';
import { SystemStyleObject } from '@mui/system';
import React, { forwardRef, PropsWithChildren } from 'react';

export type CustomMultiSelectContainerProps = {
    label?: JSX.Element;
    open?: boolean;
    sx?: SxProps<Theme>;
};

export const CustomMultiSelectContainer = forwardRef<HTMLDivElement, PropsWithChildren<CustomMultiSelectContainerProps>>(
    ({ label, open, sx, children }, ref) => (
        <Box
            ref={ref}
            sx={(theme) => ({
                width: '100%',
                border: 'solid 1px',
                borderColor: open ? theme.palette.secondary.main : '#C6C4C4',
                borderRadius: '8px',
                p: 1,
                height: '50px',
                ...(sx as SystemStyleObject<Theme>)
            })}
        >
            <Grid container sx={{ height: '100%' }}>
                {label && (
                    <Grid item xs={4} container alignItems="center" sx={{ height: '100%' }}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '13px',
                                textOverflow: 'ellipsis',
                                overflow: 'hidden',
                                whiteSpace: 'nowrap',
                                color: '#616161'
                            }}
                        >
                            {label}
                        </Typography>
                    </Grid>
                )}
                <Grid item xs={label ? 8 : 12} sx={{ height: '100%' }}>
                    {children}
                </Grid>
            </Grid>
        </Box>
    )
);
